<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Beden Bilgisi</label>
            <v-validator :errors="errors" parameter="SizeInformationId" :watch="size">
                <v-select-list v-model="size" :options="sizes" label="Name" placeholder="Beden Bilgisi"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Beden Değeri</label>
            <v-validator :errors="errors" parameter="ParameterOfSizeInformationId" :watch="val">
                <v-select-list v-model="val" :options="values" label="Value" placeholder="Beden Değeri"></v-select-list>
            </v-validator>
        </div>
    </div>
</template>

<script>
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
import VValidator from '@/components/VValidator.vue';

export default {
    components:{
        VValidator
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            sizes:[],
            values:[],
        }
    },
    watch:{
        "value.SizeInformationId"(oldV,newV){
            if(oldV != newV){
                this.getValues()
                this.value.ParameterOfSizeInformationId = null
            }
        }
    },
    mounted(){
        this.getSizes()
        this.getValues()
    },
    methods:{
        getSizes(){
            HumanResourcesParameterApi.SizeInformation.List().then(res=>{
                this.sizes = res.data.Data
            })
        },
        getValues(){
            if(this.value.SizeInformationId){
                HumanResourcesParameterApi.SizeInformationParameter.List(this.value.SizeInformationId).then(res=>{
                    this.values = res.data.Data
                })
            }
        }
    },
    computed:{
        size:{
            get:function(){
                return this.sizes.find(b=>b.Id==this.value.SizeInformationId)
            },
            set:function(value){
                this.value.SizeInformationId = value?.Id || null
                this.value.SizeInformationName = value?.Name
            }
        },
        val:{
            get:function(){
                return this.values.find(b=>b.Id==this.value.ParameterOfSizeInformationId)
            },
            set:function(value){
                this.value.ParameterOfSizeInformationId = value?.Id || null
                this.value.ParameterOfSizeInformationName = value?.Value
            }
        },
    }
}
</script>

<style>

</style>